import {cva, type VariantProps} from 'platform/shared-tw';

import type {ReactNode} from 'react';

const buttonVariants = cva(
  'px-6 py-3 font-semibold rounded-lg transition-colors cursor-pointer font-[Geist] text-base border-none outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        primary:
          'bg-(--color-mira-gray-100) text-white hover:bg-(--color-mira-gray-80) focus-visible:ring-(--color-mira-gray-60)',
        secondary:
          'bg-transparent border border-solid border-(--color-mira-gray-40) text-(--color-text-primary) hover:border-(--color-mira-gray-60) focus-visible:ring-(--color-mira-gray-40)',
      },
      isDisabled: {
        true: 'opacity-50 cursor-not-allowed pointer-events-none',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      isDisabled: false,
    },
  }
);

export interface ButtonProps extends VariantProps<typeof buttonVariants> {
  readonly children: ReactNode;
  readonly onClick?: () => void;
  readonly type?: 'button' | 'submit';
  readonly disabled?: boolean;
}

export function Button(props: ButtonProps) {
  const isDisabled = props.disabled ?? false;

  const handleClick = () => {
    if (!isDisabled && props.onClick) {
      props.onClick();
    }
  };

  return (
    <button
      type={props.type ?? 'button'}
      onClick={handleClick}
      disabled={isDisabled}
      className={buttonVariants({variant: props.variant, isDisabled})}
    >
      {props.children}
    </button>
  );
}
